export function scrollToFirstError() {
  const firstError = document.querySelector(".form-validation-error");
  if (firstError) {
    // @ts-ignore
    firstError.style.scrollMarginTop = "200px";
    firstError.scrollIntoView({ behavior: "smooth", block: "start" });
  }
}
